<div class="bets-accepted-modal">
  <div class="modal-header">
    <h1>{{ 'slip_accepted' | translate }}</h1>
  </div>
  <div class="modal-body">
    <button class="modal-action-button" (click)="slipRestore()"><span class="action-icon">&#x21bb;</span>{{ 'slipdetail_re_use_slip' | translate }}</button>
    <button class="modal-action-button" (click)="goMyBets()"><span class="action-icon">&#x1f4b3;</span>{{ 'MyBets' | translate }}</button>
    <button class="modal-confirm-button" (click)="this.dialogRef.close()">{{ 'OK' | translate }}</button>
  </div>
</div>
